import { render } from "./TeamInvitations.vue?vue&type=template&id=53bb5752"
import script from "./TeamInvitations.vue?vue&type=script&lang=js"
export * from "./TeamInvitations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__